// extracted by mini-css-extract-plugin
module.exports = {"smallScreen":"767px","mediumScreen":"1023px","largeScreen":"1300px","extraLargeScreen":"1600px","qual":"QualificationTile_qual__1jYv_"};